var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { LocalStorageService } from '../../_shared/services/LocalStorageService';
import { detectIncognito } from 'detectincognitojs';
import { logger } from '../utilites/logger';
var FingerprintServiceBase = /** @class */function () {
  function FingerprintServiceBase() {
    this.lsPropName = 'FP_VISITOR';
    this.isDev = false;
  }
  FingerprintServiceBase.prototype.init = function (isDev) {
    return __awaiter(this, void 0, void 0, function () {
      var result, _a, _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (isDev) this.isDev = isDev;
            _b = (_a = JSON).stringify;
            return [4 /*yield*/, this.detect()];
          case 1:
            result = _b.apply(_a, [_c.sent()]);
            LocalStorageService.setItem(this.lsPropName, result);
            return [2 /*return*/, this.detected];
          // just to invoke dev log in console
        }
      });
    });
  };
  FingerprintServiceBase.prototype.detect = function () {
    return __awaiter(this, void 0, void 0, function () {
      var detected, fingerprintId, fpVisitorId, fpIncognito, result;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            detected = this.detected;
            return [4 /*yield*/, this.getFingerprint()];
          case 1:
            fingerprintId = _a.sent();
            fpVisitorId = detected && (detected === null || detected === void 0 ? void 0 : detected.fpVisitorId) && detected.fpVisitorId !== fingerprintId // if already detected and stored
            ? detected.fpVisitorId // use old one
            : fingerprintId;
            return [4 /*yield*/, this.isIncognito()];
          case 2:
            fpIncognito = _a.sent();
            result = {
              fpVisitorId: fpVisitorId,
              fpIncognito: fpIncognito
            };
            logger.info('FingerprintService', 'detect!', result);
            return [2 /*return*/, result];
        }
      });
    });
  };
  Object.defineProperty(FingerprintServiceBase.prototype, "detected", {
    get: function () {
      var detectedJSON = LocalStorageService.getItem(this.lsPropName);
      var detected = {
        fpVisitorId: 'unknown',
        fpIncognito: 'unknown'
      }; // fallback val
      try {
        detected = detectedJSON ? JSON.parse(detectedJSON) : null;
      } catch (e) {
        logger.log(e);
      }
      logger.info('FingerprintService', 'get detected', detected);
      return detected;
    },
    enumerable: false,
    configurable: true
  });
  FingerprintServiceBase.prototype.getFingerprint = function () {
    return __awaiter(this, void 0, void 0, function () {
      var fingerprintPromise, FP, result;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            fingerprintPromise = FingerprintJS.load();
            return [4 /*yield*/, fingerprintPromise];
          case 1:
            FP = _a.sent();
            return [4 /*yield*/, FP.get()];
          case 2:
            result = _a.sent();
            return [2 /*return*/, result === null || result === void 0 ? void 0 : result.visitorId];
        }
      });
    });
  };
  FingerprintServiceBase.prototype.isIncognito = function () {
    return __awaiter(this, void 0, void 0, function () {
      var result;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, detectIncognito()];
          case 1:
            result = _a.sent();
            return [2 /*return*/, result === null || result === void 0 ? void 0 : result.isPrivate];
        }
      });
    });
  };
  return FingerprintServiceBase;
}();
export var FingerprintService = new FingerprintServiceBase();